import { React, useState, useEffect, useContext } from "react";
import { AppContext } from '../../../../AppStore';
import axios from "axios";
import Swal from "sweetalert2";
import Button from "@mui/material/Button";
import DownloadIcon from '@mui/icons-material/Download';
import Moment from 'moment';
import GridNoRow from '../../../../common/GridNoRow';
import { DataGrid, GridActionsCellItem, useGridApiRef } from '@mui/x-data-grid';
import { useParams } from 'react-router-dom';
import { useNavigate, useLocation } from "react-router-dom";

const MOB_PurchaseDetail = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();
    const fromSearch = location.state?.fromSearch || {};
    const appStore = useContext(AppContext);
    const [MenuID, setMenuID] = useState(0);
    const [MenuName, setMenuName] = useState('');
    const [MenuUpdateExistYN, setMenuUpdateExistYN] = useState('N');
    const [MenuDeleteExistYN, setMenuDeleteExistYN] = useState('N');
    const [MenuUpdateYN, setMenuUpdateYN] = useState('N');
    const [MenuDeleteYN, setMenuDeleteYN] = useState('N');
    const [originRows, setOriginRows] = useState([]);
    const [data, setData] = useState(null);
    const [itemRows, setItemRows] = useState([]);
    const [itemColumns, setItemColumns] = useState([]);
    const [userRows, setUserRows] = useState([]);
    const [userColumns, setUserColumns] = useState([]);
    const [fileRows, setFileRows] = useState([]);
    const [fileColumns, setFileColumns] = useState([]);

    useEffect(() => {
        // 권한 설정은 주석 처리된 상태
        if(params.purchase_id === null || typeof params.purchase_id === 'undefined'){
            navigate("/m/purchase", { state: { fromSearch } });
        }

        setTimeout(() => { // 초기 화면인 경우 늦게 표시 됨.
            const accessList = JSON.parse(localStorage.getItem("nav"));
            
            if (Array.isArray(accessList) && accessList.filter(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).length > 0) {
                setMenuID(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_id);
                setMenuName(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_name);
                setMenuUpdateExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_exist_yn);
                setMenuDeleteExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_exist_yn);
                setMenuUpdateYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_yn);
                setMenuDeleteYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_yn);
            } else {
                Swal.fire({
                    title: '<p style="color:red">접근 권한 오류</p>',
                    text: '화면에 접근 권한이 없습니다.',
                    confirmButtonText: '확인',
                    confirmButtonColor: '#7066e0',
                    timer: 5000,
                    timerProgressBar: true
                }).then((value) => {
                    return navigate(-1);
                });
            }
        }, 800);
    }, []);
    
    useEffect(() => {
        setItemColumns([
            { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
            { field: 'purchase_item_id', headerName: 'purchase_item_id', headerAlign: 'center', align:'center' },
            { field: 'purchase_item_name', headerName: '품목', width: 250, headerAlign: 'center', align:'left' },
            { field: 'purchase_item_count', headerName: '발주수량', type: 'number', width: 130, headerAlign: 'center', align:'right' },
            { field: 'purchase_item_price_currency_name', headerName: '통화단위', type: 'text', width: 130, headerAlign: 'center', align:'center' },
            { field: 'purchase_item_price', headerName: '단가', type: 'number',width: 120, headerAlign: 'center', type: 'number' },
            { field: 'purchase_item_sv_price', headerName: '공급가액', type: 'number', width: 130, headerAlign: 'center', align:'right' },
            { field: 'purchase_item_vat_price', headerName: '부가세액', type: 'number',width: 130, headerAlign: 'center', align:'right' },
            { field: 'purchase_item_total_price', headerName: '합계금액', type: 'number',width: 130, headerAlign: 'center', align:'right' },
        ]);

        setUserColumns([
            { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
            { field: 'purchase_user_id', headerName: 'purchase_user_id', width: 0, headerAlign: 'center' },
            { field: 'purchase_user_name', headerName: '담당자명', width: 150, headerAlign: 'center', align:'center' },
            { field: 'purchase_user_dept_name', headerName: '담당자부서', width: 150, headerAlign: 'center', align:'center' },
            { field: 'purchase_user_position_name', headerName: '담당자직위', width: 150, headerAlign: 'center', align:'center' },
            { field: 'purchase_user_type_name', headerName: '담당자유형', type: 'text', width: 150, headerAlign: 'center', align:'center' },
            { field: 'purchase_user_bigo', headerName: '비고', width: 350, headerAlign: 'center', align:'left' }
        ]);

        setFileColumns([
            {
                field: 'download',
                headerName: '다운로드',
                width: 100,
                type:'actions',
                disableClickEventBubbling: true,
                getActions: (params) => [
                    <GridActionsCellItem icon={<DownloadIcon color={ "primary" } />} onClick={() => {fileDownloadClick(params)}} label="Download" />
                ],
                headerAlign: 'center', 
                align:'center'
            },
            { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
            { field: 'file_name_sever', headerName: 'file_name_sever', width: 0, headerAlign: 'center' },
            { field: 'file_size', headerName: 'file_size', width: 0, headerAlign: 'center' },
            { field: 'file_type', headerName: 'file_type', width: 0, headerAlign: 'center' },
            { field: 'file_extension', headerName: 'file_extension', width: 0, headerAlign: 'center' },
            { field: 'file_name', headerName: '파일명', width: 270, headerAlign: 'center' },
            { field: 'file_type_name', headerName: '유형', width: 120, headerAlign: 'center', align:'center' },
            { field: 'file_size_dp', headerName: '크기', width: 120, headerAlign: 'center', align:'right' },
            { field: 'reg_user_name', headerName: '등록자', width: 120, headerAlign: 'center', align:'center' },
            { field: 'reg_datetime', headerName: '등록일시', width: 180, headerAlign: 'center', align:'center' }
        ]);
        
        if(String(MenuID) !== String(0) && typeof fromSearch.originRows === 'undefined'){
            handleSearch();
        }else{
            setOriginRows(fromSearch.originRows);
        }
    }, [MenuID]);

    useEffect(() => {
        if(typeof originRows !== 'undefined'){
            if(originRows.length > 0){
                setData(
                    {
                        purchase_id: Number(originRows[0].purchase_id),
                        purchase_number: originRows[0].purchase_number,
                        purchase_date: originRows[0].purchase_date,
                        purchase_name: originRows[0].purchase_name,
                        purchase_partner_id: Number(originRows[0].purchase_partner_id),
                        purchase_partner_name: originRows[0].purchase_partner_name,
                        purchase_partner_manager: originRows[0].purchase_partner_manager,
                        purchase_partner_manager_phone: originRows[0].purchase_partner_manager_phone,
                        purchase_partner_manager_mail: originRows[0].purchase_partner_manager_mail,
                        purchase_bigo: originRows[0].purchase_bigo,
                        purchase_ref_purchase_id: Number(originRows[0].purchase_ref_purchase_id)
                    }
                )

                var itemData = originRows.filter((item, index) => {
                    return (
                        originRows.findIndex((item2, index2) => {
                        return typeof item.purchase_item_seq !== 'undefined' && item.purchase_item_seq === item2.purchase_item_seq;
                        }) === index
                    );
                });

                itemData = itemData.sort(function(a, b) { 
                    return a.purchase_item_seq < b.purchase_item_seq ? -1 : a.purchase_item_seq > b.purchase_item_seq ? 1 : 0;
                });
                
                setItemRows(itemData.map((item, index) => ({
                    id: item.purchase_item_seq,
                    purchase_item_id: item.purchase_item_id,
                    purchase_item_name: item.purchase_item_name + ' ' +appStore.ITEM_FULL_SPEC_MAKE( item.purchase_item_spec, item.purchase_item_width, item.purchase_item_depth, item.purchase_item_height),
                    purchase_item_count: item.purchase_item_count,
                    purchase_item_price_currency: item.purchase_item_price_currency,
                    purchase_item_price_currency_name: item.purchase_item_price_currency_name,
                    purchase_item_price: item.purchase_item_price,
                    purchase_item_sv_price: item.purchase_item_sv_price,
                    purchase_item_vat_price: item.purchase_item_vat_price,
                    purchase_item_total_price: item.purchase_item_total_price
                })));

                var userData = originRows.filter((item, index) => {
                    return (
                        originRows.findIndex((item2, index2) => {
                            return typeof item.purchase_user_seq !== 'undefined' && item.purchase_user_seq === item2.purchase_user_seq;
                        }) === index
                    );
                });
            
                userData = userData.sort(function(a, b) { 
                    return a.purchase_user_seq < b.purchase_user_seq ? -1 : a.purchase_user_seq > b.purchase_user_seq ? 1 : 0;
                });
                
                setUserRows(userData.map((item, index) => ({
                    id: item.purchase_user_seq,
                    purchase_user_id: item.purchase_user_id,
                    purchase_user_name: item.purchase_user_name,
                    purchase_user_dept_name: item.purchase_user_dept_name,
                    purchase_user_position_name: item.purchase_user_position_name,
                    purchase_user_type: item.purchase_user_type,
                    purchase_user_type_name: item.purchase_user_type_name,
                    purchase_user_bigo: item.purchase_user_bigo
                })));
            
                var fileData = originRows.filter((item, index) => {
                    return (
                        originRows.findIndex((item2, index2) => {
                            return typeof item.purchase_file_id !== 'undefined' && item.purchase_file_id === item2.purchase_file_id;
                        }) === index
                    );
                });
            
                fileData = fileData.sort(function(a, b) { 
                    return a.purchase_file_id < b.purchase_file_id ? -1 : a.purchase_file_id > b.purchase_file_id ? 1 : 0;
                });
            
                setFileRows(fileData.map((item, index) => ({
                    id: item.purchase_file_id,
                    file_name_sever: item.purchase_file_name_sever,
                    file_size: item.purchase_file_size,
                    file_type: item.purchase_file_type,
                    file_extension: item.purchase_file_extension,
                    file_name: item.purchase_file_name,
                    file_type_name: item.purchase_file_type_name,
                    file_size_dp: item.purchase_file_size_dp,
                    reg_user_name: item.purchase_file_user_name,
                    reg_datetime: Moment(item.purchase_file_user_datetime).format('YYYY-MM-DD HH:mm:ss')
                })));
            }
        }
    }, [originRows]);

    const handleSearch = () => {
        if (appStore.loading) return;
        appStore.setLoading(true);
        
        axios.get('/api/p/Purchase/List',
            {
                params: {
                    purchase_id: params.purchase_id
                }
            },
            { withCredentials: true }
        )
        .then((response) => {
            setOriginRows(response.data);
        })
        .catch((error) => {
            appStore.capture();
        })
        .finally(() => {
            setTimeout(() => appStore.setLoading(false), 300);
        });
    };

    const fileDownloadClick = (object) => {
        const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent)
                    || (navigator.userAgent.includes('Mac') && 'ontouchend' in document);

        if (isIOS) {
            // iOS는 XHR+blob 대신, 폼 POST로 새 탭 열어 서버가 직접 다운로드 처리
            const form = document.createElement('form');
            form.method = 'POST';
            form.action = '/api/SaveCommon/FileDownload';
            form.target = '_blank'; // 새 탭 (팝업 차단 회피용: 클릭 안에서 즉시 submit)

            const add = (n, v) => {
                const input = document.createElement('input');
                input.type = 'hidden';
                input.name = n;
                input.value = v ?? '';
                form.appendChild(input);
            };
            add('fileName', object.row.file_name);
            add('fileNameSever', object.row.file_name_sever);
            document.body.appendChild(form);
            form.submit();
            form.remove();
            return;
        }

        // 나머지(PC/안드): 기존 axios + blob
        axios.post(
            '/api/SaveCommon/FileDownload',
            new URLSearchParams({
                fileName: object.row.file_name,
                fileNameSever: object.row.file_name_sever
            }),
            { withCredentials: true, responseType: 'blob' }
        ).then((res) => {
            if (res.status !== 200) return appStore.capture();
            const type = res.headers?.['content-type'] || 'application/octet-stream';
            const blob = new Blob([res.data], { type });
            const url  = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = object.row.file_name || 'download.bin';
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(url);
        }).catch((e) => {
            appStore.capture();
            console.log('다운로드 실패', e);
        });
    };

    const handleList = () => {
        navigate("/m/purchase", { state: { fromSearch } });
    };

    return (
        <div style={{ width: '100%', display: String(MenuID) === String(0) ? 'hidden' : 'block' }}>
            <div className="M_menubox">
                <div className="menu-action">
                    <div className="menu-title">{ MenuName }</div>
                    <div style={{ float: 'right' }}>
                        <Button
                            onClick={handleList}
                            className="M_btn-p"
                            sx={{
                                m: 1,
                                fontSize: 15,
                                color: "white", 
                                borderColor: "black", 
                                backgroundColor: "black",
                                ":hover": { boxShadow: "2px 2px 2px black" , backgroundColor: "black", borderColor: "black"}
                            }}
                            variant="outlined">
                            목록
                        </Button>
                    </div>
                </div>
            </div>

            <div className="M_contents">
                <div style={{ overflow: 'hidden' }}>
                    {/* 발주 기본 정보 */}
                    {data ? (
                        <>
                        <div style={{
                            backgroundColor: '#fdfdfd',
                            marginTop: '10px',
                            borderRadius: '12px',
                            padding: '10px',
                            marginBottom: '24px',
                            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
                            border: '1px solid #eee'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
                            <span style={{ fontSize: '24px', marginRight: '8px' }}>ℹ️</span>
                            <h2 style={{ fontSize: '22px', fontWeight: '700', color: '#222', margin: 0 }}>발주 정보</h2>
                            </div>

                            <div style={{ padding: '8px 0', borderBottom: '1px solid #eee' }}>
                            <div style={{ fontSize: '18px', fontWeight: '600', color: '#444' }}>발주명</div>
                            <div style={{ fontSize: '16px', color: '#333', marginTop: '4px' }}>{data.purchase_name || '-'}</div>
                            </div>

                            <div style={{ padding: '8px 0', borderBottom: '1px solid #eee' }}>
                            <div style={{ fontSize: '18px', fontWeight: '600', color: '#444' }}>발주일자</div>
                            <div style={{ fontSize: '16px', color: '#333', marginTop: '4px' }}>{data.purchase_date || '-'}</div>
                            </div>

                            <div style={{ padding: '8px 0', borderBottom: '1px solid #eee' }}>
                            <div style={{ fontSize: '18px', fontWeight: '600', color: '#444' }}>발주번호</div>
                            <div style={{ fontSize: '16px', color: '#333', marginTop: '4px' }}>{data.purchase_number || '-'}</div>
                            </div>

                            <div style={{ padding: '8px 0', borderBottom: '1px solid #eee' }}>
                            <div style={{ fontSize: '18px', fontWeight: '600', color: '#444' }}>발주처</div>
                            <div style={{ fontSize: '16px', color: '#333', marginTop: '4px' }}>{data.purchase_partner_name || '-'}</div>
                            </div>

                            <div style={{ padding: '8px 0', borderBottom: '1px solid #eee' }}>
                            <div style={{ fontSize: '18px', fontWeight: '600', color: '#444' }}>발주처 담당자</div>
                            <div style={{ fontSize: '16px', color: '#333', marginTop: '4px' }}>
                                {
                                [data.purchase_partner_manager, data.purchase_partner_manager_phone, data.purchase_partner_manager_mail]
                                    .filter((v) => v && v.trim() !== '')
                                    .join(' / ') || '-'
                                }
                            </div>
                            </div>

                            <div style={{ padding: '8px 0' }}>
                            <div style={{ fontSize: '18px', fontWeight: '600', color: '#444' }}>비고</div>
                            <div 
                                style={{ 
                                fontSize: '16px', 
                                color: '#333', 
                                marginTop: '4px',
                                whiteSpace: 'pre-wrap', // 줄바꿈 유지
                                lineHeight: '1.5'       // 가독성 좋게 줄 간격 추가
                                }}
                            >
                                {(data.purchase_bigo && data.purchase_bigo.trim() !== '') 
                                ? data.purchase_bigo 
                                : '-'}
                            </div>
                            </div>
                        </div>

                        <div style={{
                            backgroundColor: '#fdfdfd',
                            marginTop: '10px',
                            borderRadius: '12px',
                            padding: '10px',
                            marginBottom: '24px',
                            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
                            border: '1px solid #eee'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
                            <span style={{ fontSize: '24px', marginRight: '8px' }}>ℹ️</span>
                            <h2 style={{ fontSize: '22px', fontWeight: '700', color: '#222', margin: 0 }}>발주 품목</h2>
                            </div>

                            <div style={{ padding: '0px', height: '300px' }}>
                                <DataGrid
                                    rows={itemRows}
                                    columns={itemColumns}
                                    slots={{
                                        noRowsOverlay: GridNoRow,
                                    }}
                                    initialState={{ 
                                        density: 'compact',
                                        pagination: {
                                            paginationModel: { pageSize: 5, page: 0 },
                                        },
                                    }}
                                    columnVisibilityModel={{id: false, purchase_item_id: false}}              
                                    sx={{
                                        '& .MuiDataGrid-columnHeaderTitle': {
                                        fontSize: '15px',
                                        fontWeight: 'bold'
                                        }
                                    }}
                                />
                            </div>
                        </div>

                        <div style={{
                            backgroundColor: '#fdfdfd',
                            marginTop: '10px',
                            borderRadius: '12px',
                            padding: '10px',
                            marginBottom: '24px',
                            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
                            border: '1px solid #eee'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
                            <span style={{ fontSize: '24px', marginRight: '8px' }}>ℹ️</span>
                            <h2 style={{ fontSize: '22px', fontWeight: '700', color: '#222', margin: 0 }}>발주 담당자</h2>
                            </div>

                            <div style={{ padding: '0px', height: '300px' }}>
                                <DataGrid
                                    rows={userRows}
                                    columns={userColumns}
                                    slots={{
                                        noRowsOverlay: GridNoRow,
                                    }}
                                    initialState={{ 
                                        density: 'compact',
                                        pagination: {
                                            paginationModel: { pageSize: 5, page: 0 },
                                        },
                                    }}
                                    columnVisibilityModel={{id: false, purchase_user_id: false}}              
                                    sx={{
                                        '& .MuiDataGrid-columnHeaderTitle': {
                                        fontSize: '15px',
                                        fontWeight: 'bold'
                                        }
                                    }}
                                />
                            </div>
                        </div>

                        <div style={{
                            backgroundColor: '#fdfdfd',
                            marginTop: '10px',
                            borderRadius: '12px',
                            padding: '10px',
                            marginBottom: '24px',
                            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
                            border: '1px solid #eee'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
                            <span style={{ fontSize: '24px', marginRight: '8px' }}>ℹ️</span>
                            <h2 style={{ fontSize: '22px', fontWeight: '700', color: '#222', margin: 0 }}>발주 파일</h2>
                            </div>

                            <div style={{ padding: '0px', height: '300px' }}>
                                <DataGrid
                                    rows={fileRows}
                                    columns={fileColumns}
                                    slots={{
                                        noRowsOverlay: GridNoRow,
                                    }}
                                    initialState={{ 
                                        density: 'compact',
                                        pagination: {
                                            paginationModel: { pageSize: 5, page: 0 },
                                        },
                                    }}
                                    columnVisibilityModel={{id: false, file_name_sever: false, file_size: false, file_type : false, file_extension: false, download: false}}
                                    sx={{
                                        '& .MuiDataGrid-columnHeaderTitle': {
                                        fontSize: '15px',
                                        fontWeight: 'bold'
                                        }
                                    }}
                                />
                            </div>
                        </div>
                        </>
                    ) : (
                        <p style={{ textAlign: "center", color: "#999" }}>발주 데이터를 불러오는 중입니다...</p>
                    )}
                    </div>

            </div>
        </div>
    );
};

export default MOB_PurchaseDetail;